/* eslint-env node, browser */
import React, { useEffect, useState } from 'react'
import logo from '../../components/NavigationBar/knackly.svg'
import FaviconKnackly from './favicon.ico'
import { Button, Icon as AntdIcon, Tooltip } from 'antd'
import { connect } from 'react-redux'
import { changeColors } from '../../action/colors'
import { change as changeSettings } from '../../action/settings'
import { SketchPicker } from 'react-color'
import styled from 'styled-components'
import classNames from 'classnames'
import axios from 'axios'
import { locales } from '../../utils/locales'
import { URI } from '../../config'
import getWorkspaceURL from '../../config/workspaceURL'
import _ from 'lodash'

const style = {
  fontSize: 20,
  verticalAlign: '0.1em',
}

const styleButton = {
  boxShadow: 'none',
}

const uploadFile = async file => {
  const data = new FormData()
  data.append('file', file)
  const config = {
    baseURL: getWorkspaceURL(),
  }
  return axios.post('/upload/logo', data, config)
}

let Settings = ({
  className,
  colors,
  changeColors,
  settings,
  changeSettings,
}) => {
  const [isOpenByIndex, setOpen] = useState(-1)
  const [isActive, setActive] = useState(false)
  const [label, setLabel] = useState(settings.label)
  const [size, setSize] = useState(settings.size)
  const [termsForExternal, setTermsForExternal] = useState(
    settings.termsForExternal)
  const [logoLocal, setLogoLocal] = useState(settings.logo)
  const [isRegistration, setRegistration] = useState(settings.isRegistration)
  const [locale, setLocaleState] = useState(settings.locale)
  const [portalName, setPortalName] = useState(settings.portalName)
  const [favicon, setFavicon] = useState(settings.favicon)
  const [migration, setMigration] = useState(
    _.get(window.knacklyAddons, 'migration', false))

  useEffect(() => {
    if (label !== undefined) {
      if (label !== settings.label) {
        setActive(true)
      }
    }
    if (size !== undefined) {
      if (size !== settings.size) {
        setActive(true)
      }
    }
    if ((termsForExternal !== settings.termsForExternal)) {
      setActive(true)
    }
    if (logoLocal !== undefined && settings.logo !== logoLocal) {
      setActive(true)
    }

    if (portalName !== undefined && settings.portalName !== portalName) {
      setActive(true)
    }
    if (favicon !== undefined && settings.favicon !== favicon) {
      setActive(true)
    }
  }, [label, size, logoLocal, termsForExternal, portalName, favicon])

  const reset = (nextData) => {
    setActive(false)
    setLabel(nextData.label)
    setSize(nextData.size)
  }

  const save = async () => {
    const nextData = {
      label: label !== undefined ? label : settings.label || settings.label,
      size: size !== undefined ? size : settings.size || settings.size,
      locale: locale !== undefined ? locale : settings.locale ||
        settings.locale,
      termsForExternal: termsForExternal !== undefined
        ? termsForExternal
        : settings.termsForExternal ||
        settings.termsForExternal,
      portalName: portalName !== undefined ? portalName : settings.portalName ||
        settings.portalName,
      logo: logoLocal,
      favicon: favicon,
      colors,
      isRegistration,
      migration,
    }
    _.set(window, 'knacklyAddons.migration', migration)
    await axios.post('/api/settings', nextData)
    await changeSettings(nextData)
    reset(nextData)
  }

  const getDefaultLogo = () => {
    if (window.rightLogo.length) {
      const blob = new Blob([window.rightLogo], { type: 'image/svg+xml' })
      return URL.createObjectURL(blob)
    }
    if (window.knacklyAddons.whiteLabel) {
      return 'https://placehold.co/200x200?text=logo'
    }
    return logo
  }
  const getDefaultFavicon = () => {
    if (favicon) {
      if (favicon.includes('data:')) {
        return favicon
      } else {
        return `${URI}/${window.tenancy}/${favicon}`
      }
    }
    if (settings.favicon) {
      if (settings.favicon.includes('data:')) {
        return settings.favicon
      }
    }
    if (window.knacklyAddons.whiteLabel) {
      return 'https://placehold.co/200x200?text=logo'
    }
    return FaviconKnackly
  }
  return (
    <div className={'container-fluid py-2'}>
      <label className={'mb-2 text-uppercase'}>{'Settings'}</label>
      <div className={classNames('w-100 border border-dark p-4', className)}>
        <div className={'row'}>
          <div className={'col-3'}>
            <div className="form-group">
              <label htmlFor="displayName">{'Display name'}</label>
              <input type="text" className="form-control rounded-0"
                     id="displayName"
                     placeholder={settings.label} value={label}
                     onChange={event => setLabel(event.target.value)}/>
            </div>
            <div>
              <label htmlFor={'defaultLocale'}>{'Default Locale'}</label>
              <select className="form-control" id="defaultLocale"
                      value={locale}
                      onChange={event => {
                        setActive(true)
                        setLocaleState(event.target.value)
                      }}>
                {Object.values(locales).map(locale => (
                  <option key={locale.code}
                          value={locale.code}>{locale.description}</option>
                ))}
              </select>
            </div>
            <div className="form-group mt-2">
              <div className="form-check">
                <input className="form-check-input" type="checkbox"
                       id="registration"
                       onChange={() => {
                         setMigration(!migration)
                         setActive(true)
                       }}
                       checked={migration}/>
                <label className="form-check-label" htmlFor="registration">
                  {'Enable migration feature (beta)'}
                </label>
              </div>
            </div>
            <div className="form-group mt-2">
              <label>{'Logo'}</label>
              <div className={'w-100 my-2'}>
                <img className={'w-100'}
                     src={logoLocal
                       ? `${URI}/${window.tenancy}/${logoLocal}`
                       : getDefaultLogo()}
                     alt="Knackly"/>
              </div>
              <input type={'file'} id={'LogoFileUpload'} className={'d-none'}
                     accept={'image/*'} onChange={async e => {
                const { data } = await uploadFile(e.target.files[0])
                setLogoLocal(data.url)
              }
              } name={'uploadFile'}/>
              <label className="btn btn-secondary dart-btn my-2 text-uppercase"
                     htmlFor={'LogoFileUpload'}>{
                'Change logo'}</label>
              <button
                className="btn btn-secondary dart-btn my-2 ml-2 text-uppercase"
                onClick={() => {
                  setLogoLocal('')
                  setActive(true)
                }}>
                {'Remove logo'}
              </button>
            </div>
            {window.knacklyAddons.whiteLabel &&
              (<div className="form-group mt-2">
                <label>{'Favicon'}</label>
                <div className={'w-100 my-2'}>
                  <img className={'w-100'}
                       src={getDefaultFavicon()}
                       alt="Knackly"/>
                </div>
                <input type={'file'} id={'FaviconFileUpload'}
                       className={'d-none'}
                       accept=".ico" onChange={async e => {
                  const { data } = await uploadFile(e.target.files[0])
                  setFavicon(data.url)
                }
                } name={'uploadFile'}/>
                <label
                  className="btn btn-secondary dart-btn my-2 text-uppercase"
                  htmlFor={'FaviconFileUpload'}>{
                  'Change favicon'}</label>
                <button
                  className="btn btn-secondary dart-btn my-2 ml-2 text-uppercase"
                  onClick={() => {
                    setFavicon('')
                    setActive(true)
                  }}>
                  {'Remove favicon'}
                </button>
              </div>)}
          </div>
          <div className={'col-3'}>
            <div className="form-group">
              <label htmlFor="fontsize">{'Font size'}</label>
              <input type="number" className="form-control rounded-0"
                     id="fontsize"
                     placeholder={settings.size} value={size} min={4}
                     max={32}
                     onChange={event => {
                       const val = parseInt(event.target.value)
                       console.log(val)
                       if (val < 101 || isNaN(val)) {
                         setSize(event.target.value)
                       }
                     }}/>
            </div>
            <div className={'row'}>
              <div className={'col-12'}><label>{'Colors'}:</label></div>
              {colors.map((color, index) => (
                <div className={'col-4'} key={'color-' + index}>
                  <div className={'d-flex mb-1'}>
                    <div className={'theme-swatch'}
                         onClick={() => setOpen(index)}>
                      <div className={'theme-color'}
                           style={{ background: color }}/>
                    </div>
                    <label
                      className={'mx-2 my-0'}>
                      {index === 0 && 'Accent'}
                      {index === 1 && 'Back'}
                      {index === 2 && 'Menu'}
                    </label>
                  </div>
                  {isOpenByIndex === index &&
                    (<div className={'theme-popover'}>
                      <div className={'theme-cover'}
                           onClick={() => setOpen(-1)}/>
                      <SketchPicker
                        color={color}
                        onChangeComplete={val => {
                          colors[index] = val.hex
                          changeColors([...colors])
                          setActive(true)
                        }}
                      />
                    </div>)}

                </div>))}
            </div>
            <div className="form-group mt-3">
              <div className="form-check">
                <input className="form-check-input" type="checkbox"
                       id="registration"
                       onChange={() => {
                         setRegistration(!isRegistration)
                         setActive(true)
                       }}
                       checked={isRegistration}/>
                <label className="form-check-label" htmlFor="registration">
                  {'Allow registration for external users'}
                </label>
              </div>
            </div>
            {isRegistration && (<div className="form-group">
              <label
                htmlFor="ExternalUserPortalName">{'External user portal name'}</label>
              <input type="text" className="form-control rounded-0"
                     id="displayName"
                     placeholder={''} value={portalName}
                     onChange={event => setPortalName(event.target.value)}/>
            </div>)}
            {isRegistration && (<div className="form-group">
              <label
                htmlFor={'TermsOfService'}>{'Additional Terms of Service for External Users'}</label>
              <textarea id="TermsOfService"
                        className={'form-control rounded-0'}
                        value={termsForExternal}
                        onChange={event => setTermsForExternal(
                          event.target.value)}
                        rows="10"/>
            </div>)}
          </div>
          <div className={'col-3'}/>
          <div className={'col-3'}>
            {isActive && (
              <div className={'float-right'}>
                <Tooltip placement="bottom" title={'Save'}>
                  <Button shape="circle" style={styleButton} onClick={save}
                          className="m-1 border-0 bg-transparent">
                    <AntdIcon type="save" style={style}/>
                  </Button>
                </Tooltip>

                <Tooltip placement="bottom" title={'Revert'}>
                  <Button shape="circle" style={styleButton}
                          onClick={() => reset({
                            label: settings.label,
                            size: settings.size,
                          })} className="m-1 border-0 bg-transparent">
                    <AntdIcon type="undo" style={style}/>
                  </Button>
                </Tooltip>
              </div>)}
          </div>
        </div>
      </div>
    </div>
  )
}

Settings = styled(Settings)`
    background-color: ${props => props.theme.colorTable.plain} !important;
    border-color: ${props => props.theme.colorTable.border} !important;
    color: ${props => props.theme.colorTable.textLight} !important;
`
const mapStateToProps = state => {
  const { colors, settings } = state
  return {
    colors,
    settings,
  }
}

const mapDispatchToProps = (dispatch) => ({
  changeColors: (colors) => dispatch(changeColors(colors)),
  changeSettings: (setting) => dispatch(changeSettings(setting)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
